import api from '../api'
import moment from 'moment'


//default state
export const DEFAULT_STATE = {
    isLoading: false,
    error: null,
    isLessonSaved: false,
    lessonById: {},
    lessons: [],
};

//types
export const LESSON_ADD = 'LESSON_ADD';
export const LESSON_ADD_SUCCESS = 'LESSON_ADD_SUCCESS';
export const LESSON_ADD_FAILURE = 'LESSON_ADD_FAILURE';
export const GET_LESSONS = 'GET_LESSONS';
export const GET_LESSONS_SUCCESS = 'GET_LESSONS_SUCCESS';
export const GET_LESSONS_FAILURE = 'GET_LESSONS_FAILURE';
export const CLEAR_LESSONS = 'CLEAR_LESSONS';

export const GET_LESSON_BY_ID = 'GET_LESSON_BY_ID';
export const GET_LESSON_BY_ID_SUCCESS = 'GET_LESSON_BY_ID_SUCCESS';
export const GET_LESSON_BY_ID_FAILURE = 'GET_LESSON_BY_ID_FAILURE';

export const UPDATE_LESSON_BY_ID = 'UPDATE_LESSON_BY_ID';
export const UPDATE_LESSON_BY_ID_SUCCESS = 'UPDATE_LESSON_BY_ID_SUCCESS';
export const UPDATE_LESSON_BY_ID_FAILURE = 'UPDATE_LESSON_BY_ID_FAILURE';

export const REMOVE_LESSON_BY_ID = 'REMOVE_LESSON_BY_ID';
export const REMOVE_LESSON_BY_ID_SUCCESS = 'REMOVE_LESSON_BY_ID_SUCCESS';
export const REMOVE_LESSON_BY_ID_FAILURE = 'REMOVE_LESSON_BY_ID_FAILURE';

//selectors
export const getIsLessonLoading = (state) => state && state.lesson && state.lesson.isLoading;
export const getError = (state) => state && state.lesson && state.lesson.error;
export const getIsLessonSaved = (state) => state && state.lesson && state.lesson.isLessonSaved;
export const getLessonById = (state) => state && state.lesson && state.lesson.lessonById;
export const getLessons = (state) => state && state.lesson && state.lesson.lessons;

//actions
export const clearLessons = () => (dispatch, state) => {
    dispatch({
        type: CLEAR_LESSONS
    });
}

export const fetchSaveLessons = (lesson) => (dispatch, state) => {
    dispatch({
        type: LESSON_ADD
    });
    api.lessonAdd(lesson)
        .then((res) => {
            dispatch({
                type: LESSON_ADD_SUCCESS,
            })
        })
        .catch(err => {
            dispatch({
                type: LESSON_ADD_FAILURE,
                payload: err.response.data.error
            })
        })
}

export const fetchLessonsById = (lessonId) => (dispatch, state) => {
    dispatch({
        type: GET_LESSON_BY_ID
    })
    api.getLessonById(lessonId)
        .then(res => {
            dispatch({
                type: GET_LESSON_BY_ID_SUCCESS,
                payload: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: GET_LESSON_BY_ID_FAILURE,
                payload: err.response.data.error
            })
        })
}

export const fetchLessonsForGroup = (group) => (dispatch, state) => {
    dispatch({
        type: GET_LESSONS
    });
    api.getLessonsForGroup(group)
        .then((res) => {
            dispatch({
                type: GET_LESSONS_SUCCESS,
                payload: res.data.sort((a, b) => moment(b.date).isBefore(a.date) ? 1 : -1)
            })
        })
        .catch(err => {
            dispatch({
                type: GET_LESSONS_FAILURE,
                payload: err.response.data.error
            })
        })
}



export const patchLessonById = (lessonInfo) => (dispatch, state) => {
    dispatch({
        type: UPDATE_LESSON_BY_ID
    })
    api.patchLessonById(lessonInfo)
        .then(res => {
            dispatch({
                type: UPDATE_LESSON_BY_ID_SUCCESS,
            })
        })
        .catch(err => {
            dispatch({
                type: UPDATE_LESSON_BY_ID_FAILURE,
                payload: err.response.data.error
            })
        })
}

export const removeLessonById = (id, group) => (dispatch, state) => {
    dispatch({
        type: REMOVE_LESSON_BY_ID
    })
    api.removeLessonById(id)
        .then(res => {
            dispatch(fetchLessonsForGroup(group));
        })
        .catch(err => {
            dispatch({
                type: REMOVE_LESSON_BY_ID_FAILURE,
                payload: err.response.data.error
            })
        })
}

//reducer
// eslint-disable-next-line
export default function (state = DEFAULT_STATE, action) {
    const { type, payload } = action;

    switch (type) {
        case LESSON_ADD:
            return { ...state, isLoading: true, error: null, isLessonSaved: false }
        case LESSON_ADD_SUCCESS:
            return { ...state, isLoading: false, error: null, isLessonSaved: true }
        case LESSON_ADD_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case GET_LESSON_BY_ID:
            return { ...state, isLoading: true, error: null, isLessonUpdated: false, lessonById: {} }
        case GET_LESSON_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null, lessonById: payload }
        case GET_LESSON_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case UPDATE_LESSON_BY_ID:
            return { ...state, isLoading: true, error: null, isLessonSaved: false }
        case UPDATE_LESSON_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null, isLessonSaved: true }
        case UPDATE_LESSON_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case REMOVE_LESSON_BY_ID:
            return { ...state, isLoading: true, error: null }
        case REMOVE_LESSON_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null }
        case REMOVE_LESSON_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case GET_LESSONS:
            return { ...state, isLoading: true, error: null, lessons: [] }
        case GET_LESSONS_SUCCESS:
            return { ...state, isLoading: false, error: null, lessons: payload }
        case GET_LESSONS_FAILURE:
            return { ...state, isLoading: false, error: payload }
        case CLEAR_LESSONS:
            return { ...state, lessons: [] }
        default:
            return state;
    }
}